import { combineReducers } from "redux";
import getPIEAnalysisCalculationReducer from "./pieAnalysisCalculationReducer";

const pieAnalysisCalculationReducer = combineReducers({
    pieAnalysisCalculationReducer: getPIEAnalysisCalculationReducer
});

export default pieAnalysisCalculationReducer;